module.exports = __webpack_public_path__ + "img/title-expired.9f5b95de.png";